<section class="notification-details no-print">
  <section class="row col-lg-12 col-md-12 col-sm-12 col-xs-12 p0 details-header">
    <section class="col-lg-8 col-md-8 col-sm-0 col-xs-12 p0"></section>
    <section class="col-lg-2 col-md-2 col-sm-6 col-xs-12 middle-row p0"><img
      src="/icons/{{baseSiteId}}/chevron-left.svg" alt="left" class="chevron-left no-print"><a
    [routerLink]="['/messageHistoryPage']" class="back no-print">Back to notifications</a></section>
    <section class="col-lg-2 col-md-2 col-sm-6 col-xs-12 p0">
      <section class="save-document mb1 mt0">
        <a class="print no-print" (click)="print()" [ngClass]="printPdf === true ? 'disabled-link' : 'print'"><img
          src="/icons/{{baseSiteId}}/print.svg" alt="Print"><span>Print</span></a>
        </section>
      </section>
    </section>
    <section class="row row-20 leftCont-rightNav display-block notifications-container">
      <section class="col-md-2 col-sm-12 col-md-pull-10 empty-sec no-print banner-large">
        @if (bannerUrl) {
          <div class="bannerImg">
            <img class="image-set-in-card banner-img" [src]="bannerUrl" alt="" />
          </div>
        }
      </section>
      <section class="col-md-10 col-sm-12 col-md-push-2 right-section p0">

        <section class="iframe">
          <div class="order-confirmation-wrapper">
            <h4 class="notiTitle"> {{notificationData?.notificationText}}
            </h4>
            <p class="notiPara">
              <span class="notiSpan">From: </span>
              {{notificationData?.fromEmail}}
            </p>
            <p class="notiPara">
              <span class="notiSpan">To: </span>
              {{notificationData?.toEmail}}
            </p>
            @if (notificationData?.isPDFEmailAttachment) {
              <div class="attachmentIconSection">
                <a href="javascript:void(0)" (click)="getAttachData()">
                  <img src="/icons/attachment-64.png">
                  <span class="notiTitle">{{notificationData?.notificationText}}</span>
                </a>
              </div>
            }
          </div>
          <iframe title="" #iframe id="valid-for-data" [height]="iframeHeight" [width]="iframeWidth"
          [attr.srcdoc]="urlSafe" name="valid-for-data" style="border:none !important"></iframe>
        </section>
      </section>

      <section class="col-md-2 col-sm-12 col-md-pull-10 empty-sec no-print banner-small">
        @if (bannerUrl) {
          <div class="bannerImg-small">
            <img class="image-set-in-card banner-img" [src]="bannerUrl" alt="" />
          </div>
        }
      </section>
    </section>
  </section>
  @if (printPdf) {
    <section [innerHTML]="sanitizer.bypassSecurityTrustHtml(urlSafeCopy)" id="print-pdf"></section>
  }
